<template>
    <div>
        <p style="display: flex;
            font-size: 30px;
            flex-direction: row;
            height: 45px;
            color: rgb(2215,114,2);
            border-bottom: solid 0.06rem rgb(193,193,193);">
            Tutorials
        </p> 
        <el-collapse v-model="activeCollapse" @change="handleChange" style="width:100%; height: auto;text-align: left;">
            <el-collapse-item name="home" >
                <template slot="title" style="margin-left: 20px;">&nbsp&nbsp&nbsp
                <i class="el-icon-s-home"></i>&nbsp Home page
                </template>
                <br/>
                <el-image class="box-img" :src="require('@/assets/tutorials/home.jpeg')" style="width:90%;display: block;margin:auto"/>
              
            </el-collapse-item>

            <el-collapse-item name="browse">
                <template slot="title" style="margin-left: 20px;">&nbsp&nbsp&nbsp
                <i class="el-icon-view"></i>&nbsp Browse page
                </template>
                <br/>
                <el-image class="box-img" :src="require('@/assets/tutorials/browse1.png')" style="width:90%;display: block;margin:auto"/>
                <el-image class="box-img" :src="require('@/assets/tutorials/browse2.png')" style="width:90%;display: block;margin:auto"/>
            </el-collapse-item>
            
            <el-collapse-item name="search">
                <template slot="title" style="margin-left: 20px;">&nbsp&nbsp&nbsp
                <i class="el-icon-search"></i>&nbsp Search page
                </template>
                <br/>
                <el-image class="box-img" :src="require('@/assets/tutorials/search1.png')" style="width:90%;display: block;margin:auto"/>
                <el-image class="box-img" :src="require('@/assets/tutorials/search2.png')" style="width:90%;display: block;margin:auto"/>
            </el-collapse-item>

            <el-collapse-item name="prediction">
                <template slot="title" style="margin-left: 20px;">&nbsp&nbsp&nbsp
                <i class="el-icon-data-line"></i>&nbsp Prediction page
                </template>
                <br/>
                <p style="margin-left:3%;font-size: 18px;text-align: left;line-height: 23px;">1.Prediction results</p>
                <el-image class="box-img" :src="require('@/assets/tutorials/prediction1.jpeg')" style="width:90%;display: block;margin:auto"/>
                <el-image class="box-img" :src="require('@/assets/tutorials/prediction2.jpeg')" style="width:90%;display: block;margin:auto"/>
                <p style="margin-left:3%;font-size: 18px;text-align: left;line-height: 23px;">2.Prediction online tool</p>
                <el-image class="box-img" :src="require('@/assets/tutorials/prediction3.jpeg')" style="width:90%;display: block;margin:auto"/>
                <el-image class="box-img" :src="require('@/assets/tutorials/prediction4.jpeg')" style="width:90%;display: block;margin:auto"/>
            </el-collapse-item>

            <el-collapse-item name="analysis">
                <template slot="title" style="margin-left: 20px;">&nbsp&nbsp&nbsp
                <i class="el-icon-aim"></i>&nbsp Analysis page
                </template>
                <br/>
                <p style="margin-left:3%;font-size: 18px;text-align: left;line-height: 23px;">1.Enrichment analysis</p>
                <el-image class="box-img" :src="require('@/assets/tutorials/analysis3.jpeg')" style="width:90%;display: block;margin:auto"/>
                <p style="margin-left:3%;font-size: 18px;text-align: left;line-height: 23px;">2.Differential analysis</p>
                <el-image class="box-img" :src="require('@/assets/tutorials/analysis.jpeg')" style="width:90%;display: block;margin:auto"/>
                <el-image class="box-img" :src="require('@/assets/tutorials/analysis2.jpeg')" style="width:90%;display: block;margin:auto"/>
            </el-collapse-item>
            
            <el-collapse-item name="visualization">
                <template slot="title" style="margin-left: 20px;">&nbsp&nbsp&nbsp
                <i class="el-icon-share"></i>&nbsp Visualization page
                </template>
                <br/>
                <p style="margin-left:3%;font-size: 18px;text-align: left;line-height: 23px;">1.PPI</p>
                <el-image class="box-img" :src="require('@/assets/tutorials/PPI.png')" style="width:90%;display: block;margin:auto"/>
                <p style="margin-left:3%;font-size: 18px;text-align: left;line-height: 23px;">2.Relation</p>
                <el-image class="box-img" :src="require('@/assets/tutorials/relation1.png')" style="width:90%;display: block;margin:auto"/>
                <el-image class="box-img" :src="require('@/assets/tutorials/relation2.png')" style="width:90%;display: block;margin:auto"/>
                <p style="margin-left:3%;font-size: 18px;text-align: left;line-height: 23px;">3.Location</p>
                <el-image class="box-img" :src="require('@/assets/tutorials/location1.png')" style="width:90%;display: block;margin:auto"/>
                <el-image class="box-img" :src="require('@/assets/tutorials/location2.png')" style="width:90%;display: block;margin:auto"/>
            </el-collapse-item>

            <el-collapse-item name="download">
                <template slot="title" style="margin-left: 20px;">&nbsp&nbsp&nbsp
                <i class="el-icon-download"></i>&nbsp Download page
                </template>
                <br/>
                <el-image class="box-img" :src="require('@/assets/tutorials/download.jpeg')" style="width:90%;display: block;margin:auto"/>
            </el-collapse-item>

            <el-collapse-item name="about">
                <template slot="title" style="margin-left: 20px;">&nbsp&nbsp&nbsp
                <i class="el-icon-info"></i>&nbsp About page
                </template>
                <br/>
                <el-image class="box-img" :src="require('@/assets/tutorials/about.png')" style="width:90%;display: block;margin:auto"/>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        activeCollapse: ['home']
      };
    },
    methods: {
      handleChange(val) {
      }
    }
  }
</script>